import {ksuOneTemplate} from './KsuOneTemplate'
 import {ksuOneTemplateRTL} from './KsuOneTemplateRTL'

export default {ksuOneTemplate,ksuOneTemplateRTL}